import { render, staticRenderFns } from "./formPage.vue?vue&type=template&id=a95a3326"
import script from "./formPage.vue?vue&type=script&lang=js"
export * from "./formPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports